/* The Reports library: cards on a white page, then one line over one table for an open report. */

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--gap);
  /* Rows take their content's height and sit together. A grid in a taller container stretches its
     auto rows by default, which left ~160px between rows of 90px cards (G-Wviewer-14). */
  align-content: start;
  margin: 0;
  padding: 14px;
  list-style: none;
  overflow-y: auto;
}

.card {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    "icon text"
    "icon group";
  align-items: start;
  gap: 2px 12px;
  width: 100%;
  min-height: 72px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color var(--dur-1) var(--ease-std),
    background-color var(--dur-1) var(--ease-std);
}

.card:hover:not(:disabled) {
  border-color: var(--accent-line);
  background: var(--accent-w);
}

.card:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.card:disabled {
  border-style: dashed;
  background: var(--panel-2);
  /* The card says what is not available, which is information: --muted (6:1), not --disabled (2.6:1). */
  color: var(--muted);
  cursor: not-allowed;
}

.cardIcon {
  display: grid;
  grid-area: icon;
  place-items: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--accent-line);
  border-radius: var(--radius-chip);
  background: var(--accent-w);
  color: var(--accent);
}

.card:disabled .cardIcon {
  border-color: var(--line);
  background: var(--panel);
  color: var(--disabled);
}

.cardText {
  display: flex;
  grid-area: text;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cardTitle {
  font-size: var(--t-body);
  font-weight: 650;
}

.cardSummary {
  color: var(--muted);
  font-size: var(--t-dense);
}

.cardGroup {
  grid-area: group;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.back,
.ghost,
.export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.back:hover,
.ghost:hover,
.export:hover {
  border-color: var(--muted);
  background: var(--panel-2);
  color: var(--ink);
}

.back:focus-visible,
.ghost:focus-visible,
.export:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.export {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--on-fill);
}

.export:hover {
  border-color: var(--accent-h);
  background: var(--accent-h);
  color: var(--on-fill);
}

.dates {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--t-dense);
  color: var(--muted);
}

.dates input {
  height: var(--h-ctl);
  padding: 0 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
}

.dates input:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.notes {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: var(--t-body);
  line-height: 1.5;
}

.notes p {
  margin: 0;
}
